<template>
	<div class="filter">
		<div class="filter-title">
			<h1>Subtipo de Documentos</h1>
		</div>
		<div class="filter-inputs">
			<input
				class="filter-inputs__investors"
				type="text"
				placeholder="Busca"
				@input="searchInputDebounce"
				v-model="searchInput"
			/>
			<ButtonPrimary
				class="filter-inputs__btn"
				label="Adicionar Subtipo de Documentos"
				size="md"
				@click="addDocSubtype"
			/>
		</div>
	</div>
</template>

<script>
import ButtonPrimary from '@/components/shared/Button/ButtonPrimary/ButtonPrimary.vue';

export default {
	name: 'TableFilter',
	components: { ButtonPrimary },
	props: {
		isWeb: {
			required: true,
		},
	},
	data: () => ({
		searchInput: null,
		debounce: null,
	}),
	created() {},
	mounted() {},
	methods: {
		addDocSubtype() {
			this.$router.push({
				path: '/dashboard/config/docSubtype/detail',
			});
		},
		searchInputDebounce() {
			clearTimeout(this.debounce);

			this.debounce = setTimeout(() => {
				this.$emit('searchFromInput', this.searchInput);
			}, 600);
		},
	},
	computed: {},
};
</script>

<style lang="scss" scoped>
@import 'TableFilter.scss';
</style>
